import '../assets/css/product-card.css';

import { Link } from 'react-router-dom';
import { Price , W_Time} from '../../assets/icones/icones';
import React, {Fragment} from "react";
import {FormatNumberByhkh} from "../../clientconfigwebapp";

const Card_Suggested_vendors_view = (props) => {


    let link_post_get="/" + props.link_to;
    link_post_get=link_post_get.replaceAll("//","")



    return (
        <Fragment>

            <style jsx>{`
                .card_Suggested_vendors {
                    padding-top: 0px !important;
                    box-sizing: border-box;
                    background: #FFFFFF;
                    border: 1px solid #F3F4F6;
                    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
                    border-radius: 8px;
                    flex: none;
                    order: 3;
                    flex-grow: 0;
                }

                .img-card_Suggested_vendors {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    cursor: pointer;
                    transition: all .3s;
                    border-top-right-radius: 10px;
                    border-top-left-radius: 10px;
                }

                .card_Suggested_vendors_title {
                    width: 100%;
                    font-size: 17px;
                    display: block;
                    padding: 10px;
                    font-family: 'iran';
                }
                
            `}</style>



            <div className='card_Suggested_vendors'>
                <div className=''>
                    <Link className={"card_Suggested_vendors_link"} to={link_post_get}>
                        <img className={"img-card_Suggested_vendors"} src={props.data_full_curent_item.image_src_b}/>
                    </Link>
                </div>
                <div>
                    <Link className={"card_Suggested_vendors_title"} to={link_post_get}>{props.data_full_curent_item.title_post}</Link>
                </div>
            </div>
        </Fragment>
    );
}

export default Card_Suggested_vendors_view;